import React from "react"

import { InvoicesPaymentsProvider } from "~/contexts/InvoicePaymentsProvider"
import IInvoice from "~/interfaces/IInvoice"
import { CampingStyleProps, CampProps, SiteProps } from "~/interfaces"
import useLogRocket from "~/hooks/useLogRocket"
import { ReactQueryProvider } from "~/components/ReactQueryProvider"
import CustomerInvoiceContent from "~/components/Invoices/PublicInvoices/CustomerInvoiceContent"

interface ComponentProps {
  invoice: IInvoice
  email: string
  site: SiteProps
  camp: CampProps
  is_admin: boolean
  camping_style: CampingStyleProps
  has_pending_payments: boolean
}

const CustomerInvoice = (props: ComponentProps) => {
  useLogRocket()

  return (
    <div className="h-full">
      <ReactQueryProvider>
        <InvoicesPaymentsProvider invoice={props.invoice} camp={props.camp} campingStyle={props.camping_style}>
          <CustomerInvoiceContent {...props} />
        </InvoicesPaymentsProvider>
      </ReactQueryProvider>
    </div>
  )
}

export default CustomerInvoice
